// 资源模块错码
export const downgradesErrorCodeMap = {
  'resource.not.exist': '资源不存在',
  'name.length.exceed': '名称长度超出限制',
  'resource.name.contain.special.characters': '资源名称包含错误编码',
  'resource.name.already.existed': '资源名称已存在'
}
